import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef, ViewChildren, ComponentFactoryResolver, ViewChild, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { IEntityModel } from '@framework/interfaces/IEntityModel';
import { ViewType, FieldType } from '@framework/core/Enums';
import { FormBuilderControl } from '@common/formbuilder/FormBuilderControl';
import { IControlChangeEventArgs } from '@common/formbuilder/IControlChangeEventArgs';
import { SelectItem, DialogService } from 'primeng/api';
import { ApiService } from '../../../services/api/api.service';
import { IdentityAuthService } from '../../../services/identity-auth/identity-auth.service';
import { FormBuilderControlType } from '../../../common/formbuilder/FormBuilderControlType';
import { NbToastrService } from '@nebular/theme';
import { appSettings } from '../../../modules/shared/components/appSettings';
import { debug } from 'util';

@Component({
  selector: 'app-mf-form-control',
  templateUrl: './mf-form-control.component.html',
  styleUrls: ['./mf-form-control.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush //Greatly helps with performance but have to be sure all change detection works or should be triggered itself when necessary https://netbasal.com/a-comprehensive-guide-to-angular-onpush-change-detection-strategy-5bac493074a4
})
export class MfFormControlComponent implements OnInit {
  private _formField: FormBuilderControl;
  private _data: any = {};
  public loadingProgress: boolean;
  filteredLookups: any;
  @Input() public formReadOnly: boolean;
  @Input() public isFilters: boolean;
  public showUpload: boolean = false;
  public dataAutoComplete: any;
  public loading: boolean = false;
  public url: string;
  @ViewChild('customControl', { static: true, read: ViewContainerRef }) customControlTarget: ViewContainerRef;
  public customControlInstance: any;
  public get formField(): FormBuilderControl { return this._formField; }
  public get fieldDisabled() {
    if (this.isFilters)
      return false;
    if (!this.formField)
      return true;
    if (this.formField.disabled)
      return true;
    if (this.formField.fieldOptions && this.formField.fieldOptions.readOnly) {
      if ({}.toString.call(this.formField.fieldOptions.readOnly) === '[object Function]') {
        let test: any = this.formField.fieldOptions.readOnly;
        return test(this.data, this.authService, this.formField)
      }
      else return this.formField.fieldOptions.readOnly;
    }
  }
  public checkChanges() {
    this.cdr.detectChanges();
  }
  private _dataObj: any;
  @Input() set dataObj(val) {
    this._dataObj = val;
    //if (this.formField && this.formField.controlType.viewType == ViewType.DateRange) {
    //  if (!val) {
    //    this._dataObj = { start: null, end: null };
    //  }
    //}
    this.dataObjChange.emit(val);
    if (this.customControlInstance) {
      this.customControlInstance.component.dataObj = this.dataObj;
    }
  }
  get dataObj() {
    return this._dataObj;
  }
  _parent: any;
  @Input() set parent(value) {
    this._parent = value;
  }
  get parent() {
    return this._parent;
  }
  @Input() extraData: any;
  @Input() public set formField(value: FormBuilderControl) {
    this._formField = value;

    if (this._formField && this._formField.lookups) {
      this.filteredLookups = this._formField.lookups;

    }
    if (this._formField.controlType.viewType == ViewType.Dropdown) {
      var _th = this;
      _th._formField.refreshLookups = function () {
        _th.refreshLookups();
        _th.cdr.detectChanges();
      }
    }
  }
  public uploadingFileCount: number = 0;
  public get data() { return this._data; }
	@Input() public set data(value) {
		//debugger;
    if (!this.formField)
      return;
    if (this.formField.controlType.viewType == ViewType.DateRange) {
      if (!value) {
        this.dataObj = { start: null, end: null };
      }
    }
    if (this.formField.controlType.viewType == ViewType.AutoComplete) {
      if (value != '' && value != null && !value.value)
        this.getInitialAutoCompleteValue(value);
      else this.dataAutoComplete = null;
      if (this.customControlInstance) {
        this.customControlInstance.component.data = this.data;
      }

    }
    else if (this.formField.controlType.viewType == ViewType.Pictures) {
      this.setGalleryImages(value)
    }
    else {
      let old = this._data;
      if (this.formField.controlType.viewType == ViewType.Date && value != '' && value != null) {
        let sa = new Date(value);
        this._data = new Date(sa.setTime(sa.getTime() + ((sa.getTimezoneOffset() * 60 * 1000) * -1)))
      }
      else this._data = value;
      this.dataChange.emit(value);
      if (this.formField.fieldOptions && this.formField.fieldOptions.change && old != this._data)
        this.formField.fieldOptions.change(old, this._data, this.dataObj, this);
      if (this.customControlInstance) {
        this.customControlInstance.component.data = this.data;
      }
    }

    if (this.formField && this.formField.lookups)
      this.filteredLookups = this.formField.lookups;

  }
  public get labelDisplay() {
    if (this.linkDisplay || this.downloadDisplay || this.customControlInstance || this.galleryDisplay)
      return false;
    else return true;
  }
  public get linkDisplay() {
    if (this.formField.controlType.viewType == ViewType.Link)
      return true;
    else return false;
  }
  public get downloadDisplay() {
    if (this.formField.controlType.viewType == ViewType.File ||
      this.formField.controlType.viewType == ViewType.Signature)
      return true;
    else return false;
  }
  public get galleryDisplay() {
    if (
      this.formField.controlType.viewType == ViewType.Pictures)
      return true;
    else return false;
  }

  public get getLinkValue() {
    if (this.data)
      if (this.data.indexOf("http") == -1)
        return 'http://' + this.data;
    return this.data;
  }
  public get getDisplayValue() {
    var self = this;
    if (this.formField.controlType.viewType == ViewType.Dropdown && this.formField.lookups) {
      var value = this.formField.lookups.filter(function (o) {
        return o.value == self.data;
      });
      if (value.length > 0)
        return value[0].label;
      return "";
    }
    if (this.formField.controlType.viewType == ViewType.AutoComplete) {
      return this.dataAutoComplete ? this.dataAutoComplete.label : "";
    }
    if (this.formField.controlType.viewType == ViewType.YesNo) {
      return this.data == true ? "Yes" : "No";
    }
    return this.data;
  }
  public refreshLookups() {
    if (this.formField && this.formField.lookups)
      this.filteredLookups = this.formField.lookups;
  }
  public viewType = ViewType;
  constructor(public apiService: ApiService, private componentFactoryResolver?: ComponentFactoryResolver, private authService?: IdentityAuthService,
    public cdr?: ChangeDetectorRef,
    public dialogService?: DialogService, private messageService?: NbToastrService) { }

  public ngOnInit() {
    if (!this.formField) {
      return;
	  }
	  //debugger;
    if (this.formField.controlType.viewType == ViewType.String && this.formField.fieldOptions && this.formField.fieldOptions.dataEndPoint) {
      this.formField.controlType.viewType = ViewType.Dropdown;
    }
    if (this.formField.controlType.viewType == ViewType.Dropdown && this.formField.fieldOptions && this.formField.fieldOptions.dataEndPoint)
      this.apiService.get(this.formField.fieldOptions.dataEndPoint.url)
        .subscribe(items => {
          this.formField.lookups = items.map(o => { return { value: o[this.formField.fieldOptions.dataIdField], label: o[this.formField.fieldOptions.dataDisplayField] } })
          this.filteredLookups = this.formField.lookups;
          this.cdr.detectChanges();
        }, error => { });

    if (this.formField.controlType.viewType == ViewType.CustomControl) {
      let component = this.formField.customControl;
      if (component) {
        let widgetComponent = this.componentFactoryResolver.resolveComponentFactory(component);
        let componentRef: any = this.customControlTarget.createComponent(widgetComponent);
        let _component: any = (componentRef.instance);
        _component.parent = this;
        _component.formField = this.formField;
        _component.data = this.data;
        _component.dataObj = this.dataObj;
        _component.formReadOnly = this.formReadOnly;
        _component.dataChange.subscribe(o => {
          this.data = o
        })
        _component.dataObjChange.subscribe(o => {
          this.dataObj = o
        })
        this.customControlInstance = { componentDetail: component, component: _component };
      }
    }

    if (this.formField.controlType.viewType == ViewType.Pictures) {
      if (this.formField.fieldOptions.dataEndPoint) {
        this.apiService.get(this.formField.fieldOptions.dataEndPoint.url)
          .subscribe(items => {
            this.data = items.map(o => { return { pictureUrl: o[this.formField.fieldOptions.dataDisplayField], id: o[this.formField.fieldOptions.dataIdField] } })

            this.cdr.detectChanges();
          }, error => { });
      }
    }

    if (this.formField && this.formField.lookups)
		  this.filteredLookups = this.formField.lookups;

	  if (this.formField && this.formField.fieldOptions && this.formField.fieldOptions.default) {
		  if ({}.toString.call(this.formField.fieldOptions.default) === '[object Function]') {
			  this.data = this.formField.fieldOptions.default();
		  }
		  else {
			  this.data = this.formField.fieldOptions.default;
		  }
	  }
		
  }
  @Output() public dataChange = new EventEmitter();
  @Output() public dataObjChange = new EventEmitter();
  @Output() public onControlDataChange = new EventEmitter<IControlChangeEventArgs>();


  public onClick(event) {
    event.stopPropagation();
  }

  public statusClick(data) {
    event.stopPropagation();
    if (this.formField.fieldOptions.canClick) {
      if (!this.formField.fieldOptions.canClick(this, data))
        return;
    }
    this.data = data;
    this.onControlDataChange.emit({ formBuilderControl: this.formField, controlValue: this.data, extraData: this.extraData, context: this });
  }

  public controlDataChange(formBuilderControl: FormBuilderControl, value: any) {
    if (typeof value != "undefined")
      this.onControlDataChange.emit({ formBuilderControl: formBuilderControl, controlValue: value, extraData: this.extraData, context: this });
  }

  public search($event, formField: FormBuilderControl, data) {
    if (this.formField.fieldOptions.dontForceAutoCompleteSelect)
      this.dataObj[this.formField.field] = $event.query;
    this.loadingProgress = true;

    
    this.apiService.get(formField.fieldOptions.searchEndPoint.url + $event.query)
      .subscribe(items => {

        this.loadingProgress = false;
        formField.lookups = items.map(o => { return { value: o[formField.fieldOptions.dataIdField], label: o[formField.fieldOptions.dataDisplayField], data: o } })
        this.cdr.detectChanges();
      }, error => { this.loadingProgress = false; });
  }

  public getInitialAutoCompleteValue(val) {
    if (this.dataAutoComplete && this.dataAutoComplete.value == val)
      return;
    if (!this.formField.fieldOptions.dataEndPoint) {
      this.dataAutoComplete = { value: val, label: val };
      this.cdr.detectChanges();
      return;
    }
    this.formField.disabled = true;
    this.apiService.get(this.formField.fieldOptions.dataEndPoint.url + val)
      .subscribe(item => {

        this.formField.disabled = false;
        this.dataAutoComplete = { value: val, label: item[this.formField.fieldOptions.dataDisplayField] };
        if (this.formField.fieldOptions && this.formField.fieldOptions.change)
          this.formField.fieldOptions.change(null, item, this.dataObj, this);
        this.cdr.detectChanges();
      }, error => { });
  }

  public onAutocompleteSelect(value, data) {
    this.dataObj[this.formField.field] = value.value;
    this.dataAutoComplete = value;
    if (this.formField.fieldOptions && this.formField.fieldOptions.change)
      this.formField.fieldOptions.change(null, value, this.dataObj, this);
    //this.cdr.detectChanges();
  }

  public onBeforeSend(event) {
    this.formField.blockSaving = true;
    //event.xhr.setRequestHeader("Authorization", `Bearer ${this.authService.access_token}`);
  }
  public onBeforeSendMulti(event) {
    this.uploadingFileCount += 1;
    this.formField.blockSaving = true;
    //event.xhr.setRequestHeader("Authorization", `Bearer ${this.authService.access_token}`);
  }

  public onProgress(event) {

  }
  public onUploadErrorMulti(event) {
    this.uploadingFileCount -= 1;
    if (this.uploadingFileCount == 0)
      this.formField.blockSaving = false;
  }
  public onUploadError(event) {

    this.formField.blockSaving = false;
  }

  public onUpload(event) {
    this.formField.blockSaving = false;
    this.data = {
      id: event.originalEvent.body.replace("\"", "").replace("\"", ""), name: event.files[0].name
    };
    this.dataObj[this.formField.fieldOptions.dataIdField] = this.data.id;
  }
  public fetchUrlFile(url) {
    this.loading = true;
    let endPoint: string = "/api/filecabinetDocument/uploadNewFilesWithUrl";
    this.apiService.post(endPoint, { url: url })
      .subscribe(respData => {
        this.loading = false;
        this.messageService.success("Successfully fetched file", "Action Successfull");
        this.data = {
          id: respData, name: "External File"
        };
        this.dataObj[this.formField.fieldOptions.dataIdField] = respData;
        this.url = null;
        this.cdr.detectChanges();
      }, error => {
        this.messageService.danger("Could not fetch file", "Action Failed");
        this.loading = false;
        this.cdr.detectChanges();
      });

  }
  public onUploadMulti(event) {
    this.uploadingFileCount -= 1;
    if (this.uploadingFileCount == 0)
      this.formField.blockSaving = false;
    var res = event.originalEvent.body;
    if (!this.dataObj[this.formField.field])
      this.dataObj[this.formField.field] = new Array();
    res.forEach(o => {
      this.dataObj[this.formField.field].push(o);
    })
    this.setGalleryImages(this.dataObj[this.formField.field])
  }
  public removeGalleryImage(item) {
    this.dataObj[this.formField.field].splice(this.dataObj[this.formField.field].indexOf(item), 1);
    this.setGalleryImages(this.dataObj[this.formField.field])
  }
  public downloadFile(id) {
    this.loading = true;
    let endPoint: string = this.formField.fieldOptions.dataEndPoint.url + id;
    this.apiService.downloadFile(endPoint)
      .subscribe(respData => {
        var blob = new Blob([respData]);
        this.apiService.saveFile(blob, this.data.name);
        this.loading = false;
        this.cdr.detectChanges();
      }, error => {
        this.loading = false;
        this.cdr.detectChanges();
        console.log('err');
      });

  }


  public galleryImages: any;

  public setGalleryImages(value) {
    this.galleryImages = [];
    if (value) {
      value.forEach(o => {
        this.galleryImages.push({ source: `${this.formField.fieldOptions.dataEndPoint.url}/${o}` });
      })
    }
  }

  handleFilter(value) {
    if (value == null || value == "")
      this.filteredLookups = this.formField.lookups;
    else
      this.filteredLookups = this.formField.lookups.filter((s) => s.label.toLowerCase().indexOf(value.toLowerCase()) !== -1);
  }

  onDataChange(value) {
    this.data = this.dataObj;
    this.dataChange.emit(this.data);
  }

  public addNewComponent() {

    const ref = this.dialogService.open(this.formField.fieldOptions.canAddNewComponent, {
      header: 'Add new',
      width: '50%',
      data: {
        parent: this
      }
    });
    ref.onClose.subscribe((newId) => {
      if (newId) {
        this.data = newId;
        if (this.formField.controlType.viewType == ViewType.AutoComplete) {
          this.dataObj[this.formField.field] = newId;
          this.getInitialAutoCompleteValue(newId);

        }
      }
    });
  }
}
